<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="lg" ref="importantNotificationModal" :visible="modal.show" :content-in-form="false"
                   :title="computedTitle" @hidden="onHidden" :show-confirmation="false" scrollable>
      <div v-html="computedBody"></div>
      <template v-slot:modal-footer>

        <div class="mr-auto" style="width: 21em">
          <b-form-checkbox v-model="doNotShowAgain" >
            {{ $t("I have read and understood the message. Do not show this message again.") }}
          </b-form-checkbox>
        </div>


        <cancel-button @click="onDismissClick">
          {{ $t('Dismiss') }}
        </cancel-button>
      </template>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import ArtisioModal from "../../artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";
  import CancelButton from "@/core/components/common/CancelButton";
  import {IMPORTANT_INFO_DISMISSED} from "@/modules/constants";

  const {mapState, mapActions} = createNamespacedHelpers('global');

  export default {
    name: "ImportantNotificationModal",
    components: {
      CancelButton,
      ArtisioModal
    },
    data() {
      return {
        doNotShowAgain: false
      }
    },
    computed: {
      ...mapState({
        modal: state => state.importantNotificationModal,
        importantNotificationInfo: state => state.importantNotificationInfo,
      }),
      computedTitle() {
        if (this.importantNotificationInfo && this.importantNotificationInfo.title) {
          return this.importantNotificationInfo.title
        }
        return this.$i18n.t('Important Information')
      },
      computedBody() {
        if (this.importantNotificationInfo && this.importantNotificationInfo.body) {
          return this.importantNotificationInfo.body
        }
        return ''
      }
    },
    methods: {
      ...mapActions(['hideImportantNotificationModal']),
      onHidden() {
        this.hideImportantNotificationModal();
      },
      onDismissClick() {
        if (this.doNotShowAgain) {
          localStorage.setItem(IMPORTANT_INFO_DISMISSED, JSON.stringify(this.importantNotificationInfo))
        }

        this.onHidden()
      }
    }
  }
</script>

<style scoped>
</style>
